import { render, staticRenderFns } from "./InactiveOrganization.vue?vue&type=template&id=ba169fd6&scoped=true&"
import script from "./InactiveOrganization.vue?vue&type=script&lang=js&"
export * from "./InactiveOrganization.vue?vue&type=script&lang=js&"
import style0 from "./InactiveOrganization.vue?vue&type=style&index=0&id=ba169fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba169fd6",
  null
  
)

export default component.exports